(function () {
  'use strict';

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function zahlKnoten(fig) {
    var typo = fig.querySelector('.oe-wert__typo');
    var zweiter = typo && typo.children[1];
    if (!zweiter) return null;
    var lauf = document.createTreeWalker(zweiter, NodeFilter.SHOW_TEXT, null);
    var k;
    while ((k = lauf.nextNode())) {
      if (/\d/.test(k.nodeValue)) return k;
    }
    return null;
  }

  function einrichten(fig) {
    if (fig.__oeWert) return;
    var k = zahlKnoten(fig);
    var m = k ? k.nodeValue.match(/\d+/) : null;
    fig.__oeWert = {
      knoten: k,
      vor: m ? k.nodeValue.slice(0, m.index) : '',
      nach: m ? k.nodeValue.slice(m.index + m[0].length) : '',
      bis: m ? parseInt(m[0], 10) : null,
      von: parseFloat(fig.getAttribute('data-von')),
      laeuft: false
    };
  }

  function laufe(fig) {
    var w = fig.__oeWert;
    if (!w || w.laeuft) return;
    w.laeuft = true;
    var t0 = null, d = 1800, zaehlt = w.knoten && w.bis != null && !isNaN(w.von);
    function schritt(ts) {
      if (t0 === null) t0 = ts;
      var t = Math.min(1, (ts - t0) / d), e = 1 - Math.pow(1 - t, 3);
      fig.style.setProperty('--oe-t', e.toFixed(3));
      if (zaehlt) w.knoten.nodeValue = w.vor + Math.round(w.von + (w.bis - w.von) * e) + w.nach;
      if (t < 1) requestAnimationFrame(schritt);
      else w.laeuft = false;
    }
    requestAnimationFrame(schritt);
  }

  var gesehen = window.IntersectionObserver ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      gesehen.unobserve(e.target);
      laufe(e.target);
    });
  }, { threshold: 0.5 }) : null;

  function start() {
    if (ruhig) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-oe-wert]'), function (fig) {
      if (fig.__oeWert) return;
      einrichten(fig);
      fig.style.setProperty('--oe-t', '0');
      var w = fig.__oeWert;
      if (w.knoten && w.bis != null && !isNaN(w.von)) w.knoten.nodeValue = w.vor + w.von + w.nach;
      if (gesehen) gesehen.observe(fig); else laufe(fig);
      fig.addEventListener('mouseenter', function () { laufe(fig); });
    });
  }

  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
